import { useMemo } from 'react';
import { Operation, Transaction } from 'types';

type UseGetReclassificationTransactionsProps = {
  reclassificationOperation: Operation | undefined;
  isOldReclassification: boolean;
};

const extractOldReclassificationTransactions = (
  operation: Operation
): Transaction[] => {
  const movements = operation?.movements || [];

  const half = movements.length / 2;
  const transactions: Transaction[] = [];

  if (movements.length % 2 !== 0) {
    return [];
  }

  // eslint-disable-next-line no-plusplus
  for (let i = 0; i < half; i++) {
    const oldMovement = movements[i];
    const newMovement = movements[i + half];

    transactions.push({
      partner: oldMovement?.partner || '',
      shareClass: oldMovement?.shareClass || '',
      shareFrom: oldMovement?.shareFrom || 0,
      shareTo: oldMovement?.shareTo || 0,
      newShareClass: newMovement?.shareClass || '',
      newShareFrom: newMovement?.shareFrom || 0,
      newShareTo: newMovement?.shareTo || 0,
      transactionType: operation?.operationType || '',
    });
  }

  return transactions;
};

export const useGetReclassificationTransactions = ({
  reclassificationOperation,
  isOldReclassification,
}: UseGetReclassificationTransactionsProps) => {
  const data = useMemo(() => {
    if (!reclassificationOperation) {
      return {
        transactions: [],
      };
    }

    const transactions: Transaction[] = isOldReclassification
      ? extractOldReclassificationTransactions(reclassificationOperation)
      : (reclassificationOperation?.transactions as Transaction[]) || [];

    return {
      transactions,
    };
  }, [reclassificationOperation, isOldReclassification]);

  return { data };
};
